import React, {useRef, useState} from 'react';
import {useToast} from "@chakra-ui/react";
import {log} from "qrcode/lib/core/galois-field";
import useBranchAPI from "../../api/branchAPI";

function BranchDetailsTillRow({
                                  row,
                                  setRemainingTills,
                                  setCanAddTillRow,
                                  initialRemainingBranchTills,
                                  GetBranchTills,
                                  setBranchTills,
                                  setInitialBranchTillsTable,
                                  setInitialRemainingBranchTills,
                                  AssignTill,
                                  BranchID,
                                  setAddText
                              }) {
    const [tillValue, setTillValue] = useState(null);
    const toast = useToast();
    const toastRef = useRef(null);

    const {
        InsertMerchantOnBoard,
        GenerateBranchTillOTP,
    } = useBranchAPI();

    const handleInsertMerchant = async (e) => {
        e.preventDefault();
        setAddText("Add");
        if (tillValue) {
            await InsertMerchantOnBoard(BranchID, tillValue);
            const newBranchTills = await GetBranchTills(BranchID);
            setBranchTills(newBranchTills.portalBranchTills);
            setInitialBranchTillsTable(newBranchTills.portalBranchTills);
            setRemainingTills(newBranchTills.remainingBranchTills);
            setInitialRemainingBranchTills(newBranchTills.remainingBranchTills);
            setCanAddTillRow(true);
            setTillValue(null);
        } else {
            toastRef.current = toast({
                position: "top",
                title: "Warning",
                description: `Choose a till, or add a till from "Edit Branch" section`,
                status: "warning",
                duration: "5000",
                isClosable: "false",
            });
        }
    };
    const handleAssignTill = async (MerchantUserOnBoardID) => {
        if (tillValue !== null && tillValue !== undefined) {
            await AssignTill(MerchantUserOnBoardID, tillValue);
            const newBranchTills = await GetBranchTills(BranchID);
            setBranchTills(newBranchTills.portalBranchTills);
            setInitialBranchTillsTable(newBranchTills.portalBranchTills);
            setRemainingTills(newBranchTills.remainingBranchTills);
            setInitialRemainingBranchTills(newBranchTills.remainingBranchTills);
            setCanAddTillRow(true);
            setTillValue(null);
        } else {
            toastRef.current = toast({
                position: "top",
                title: "Warning",
                description: "Choose a till, or add a till from Edit Branch Section!",
                status: "warning",
                duration: "5000",
                isClosable: "false",
            });
        }
    };

    const handleGenerateOTP = async (MerchantUserOnBoardID, TillBranchID) => {
        const data = await GenerateBranchTillOTP(
            MerchantUserOnBoardID,
            TillBranchID
        );
        await GetBranchTills(BranchID);
        setCanAddTillRow(true);
    };

    return (
        <tr {...row.getRowProps()}>
            {row.cells.map((cell) => {
                if (cell.column.id === "ReferenceNo") {
                    if (!cell.value) {
                        return (
                            <td>
                                <select
                                    className="ddselect"
                                    name="ReferenceNo"
                                    id="SelectReferenceNo"
                                    placeholder="Select"
                                    onChange={(e) => {
                                        setTillValue(e.target.value);
                                        setRemainingTills([
                                            ...initialRemainingBranchTills.filter((o) => o.label !== e.target.value),
                                        ]);
                                    }
                                    }
                                    // onChange={(e) => setPortalBranchDTO((prevState) => ({
                                    //     ...prevState,
                                    //     RegionID: e.target.value,
                                    // }))}
                                >
                                    <option value={-1}>Select a Till</option>
                                    {initialRemainingBranchTills.map(({label, value}) => (
                                        <option key={value} value={value}>{label}</option>
                                    ))}
                                </select>
                            </td>
                        )
                    } else {
                        return <td {...cell.getCellProps()}> {cell.render("Cell")} </td>
                    }
                }else if (cell.column.id === "assign") {
                    return cell.value.Status === "ACTIVE" && cell.value.ReferenceNo.length === 0 ? (
                        <td>
                            <button
                                className="GenerateOTP"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleAssignTill(cell.value.MerchantUserOnBoardID);
                                }}
                            >
                                Assign Till
                            </button>
                        </td>

                    ) : <td></td>
                } else if(cell.column.id === "resetGenerate") {
                    return (
                        <td>
                            <div>
                                {cell.value.Status === "ACTIVE" || cell.value.Status === "EXPIRED" ||
                                (cell.value.Status === "NEW" && cell.value.ReferenceNo) ? (
                                    <button
                                        className="GenerateOTP"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleGenerateOTP(
                                                cell.value.MerchantUserOnBoardID,
                                                cell.value.TillCount
                                            );
                                        }}>
                                        Generate OTP
                                    </button>
                                ) : null}
                                {cell.value.Status === "NEW" && !cell.value.ReferenceNo ? (
                                    <button
                                        className="GenerateOTP"
                                        onClick={handleInsertMerchant}
                                    >
                                        Generate OTP
                                    </button>
                                ) : null}

                            </div>
                        </td>
                    );
                }
                else {
                    return <td {...cell.getCellProps()}> {cell.render("Cell")} </td>
                }

            })}
        </tr>
    );
}

export default BranchDetailsTillRow;